/* eslint-disable */
/**
 * *************************************************************************
 * MOTOR BLOCKS DEFINITION
 * ***************************************************************************
 *
 * version: 1.0
 */

export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.motor = {};
    Blockly.Blocks.motor.style = 'motor_blocks';

    /**
     * motor_servo_move block definition
     */
    Blockly.Blocks.motor_servo_move = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_SERVO)
                .appendField(new Blockly.FieldImage(img_path + "arduino/servo.svg", 50, 50))
                .appendField(Blockly.Msg.MOTOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN");
            this.appendValueInput("DEGREE", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.MOTOR_SERVO_DEGREE_RANGE);
            this.appendValueInput("DELAY_TIME", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.MOTOR_SERVO_DELAY);
            this.appendDummyInput().appendField("ms");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    Blockly.Blocks.motor_servo_move_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_SERVO)
                .appendField(new Blockly.FieldImage(img_path + "arduino/servo.svg", 50, 50))
                .appendField(Blockly.Msg.MOTOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].motor), "PIN");
            this.appendValueInput("DEGREE", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.MOTOR_SERVO_DEGREE_RANGE);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    /**
     * motor_servo_read_degrees block definition
     */
    Blockly.Blocks.motor_servo_read_degrees = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_SERVO)
                .appendField(new Blockly.FieldImage(img_path + "arduino/servo.svg", 50, 50))
                .appendField(Blockly.Msg.MOTOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number")
        }
    };

    /**
     * motor_servo_oscillator_set block definition
     */
    Blockly.Blocks.motor_servo_oscillator_set = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_SERVO)
                .appendField(new Blockly.FieldImage(img_path + "arduino/servo_oscillator.svg", 60, 60)).appendField(Blockly.Msg.MOTOR_SERVO_OSCILLATOR)
                .appendField(Blockly.Msg.MOTOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN")
                .appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_AMPLITUDE, "A"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_PHASE, "P"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_OFFSET, "O"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_PERIOD, "T"]
            ]), "TYPE");
            this.appendValueInput("VALUE", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    Blockly.Blocks.motor_servo_oscillator_set_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_SERVO)
                .appendField(new Blockly.FieldImage(img_path + "arduino/servo_oscillator.svg", 60, 60)).appendField(Blockly.Msg.MOTOR_SERVO_OSCILLATOR)
                .appendField(Blockly.Msg.MOTOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].motor), "PIN")
                .appendField(new Blockly.FieldDropdown([
                    [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_AMPLITUDE, "A"],
                    [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_PHASE, "P"],
                    [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_OFFSET, "O"],
                    [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_PERIOD, "T"]
                ]), "TYPE");
            this.appendValueInput("VALUE", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    /**
     * motor_servo_oscillator_action block definition
     */
    Blockly.Blocks.motor_servo_oscillator_action = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_SERVO)
                .appendField(new Blockly.FieldImage(img_path + "arduino/servo_oscillator.svg", 60, 60)).appendField(Blockly.Msg.MOTOR_SERVO_OSCILLATOR)
                .appendField(Blockly.Msg.MOTOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital),
                "PIN").appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_REFRESH, "UPDATE"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_START, "START"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_STOP, "STOP"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_RESET, "RESET"]
            ]), "TYPE");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    Blockly.Blocks.motor_servo_oscillator_action_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_SERVO)
                .appendField(new Blockly.FieldImage(img_path + "arduino/servo_oscillator.svg", 60, 60)).appendField(Blockly.Msg.MOTOR_SERVO_OSCILLATOR)
                .appendField(Blockly.Msg.MOTOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["arduino_uno_lite"].motor),
                    "PIN").appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_REFRESH, "UPDATE"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_START, "START"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_STOP, "STOP"],
                [Blockly.Msg.MOTOR_SERVO_OSCILLATOR_RESET, "RESET"]
            ]), "TYPE");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    /**
     * motor_servo_oscillator_refresh block definition
     */
    Blockly.Blocks.motor_servo_oscillator_refresh = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_SERVO)
                .appendField(new Blockly.FieldImage(img_path + "arduino/servo_oscillator.svg", 60, 60)).appendField(Blockly.Msg.MOTOR_SERVO_OSCILLATOR)
                .appendField(Blockly.Msg.MOTOR_PIN)
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN")
                .appendField(Blockly.Msg.MOTOR_SERVO_OSCILLATOR_REFRESH);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    /**
     * motor_stepper_init block definition
     */
    Blockly.Blocks.motor_stepper_init = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_STEPPER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/stepper.svg", 50, 50))
                .appendField(Blockly.Msg.MOTOR_STEPPER_START)
                .appendField(Blockly.Msg.MOTOR_ID)
                .appendField(new Blockly.FieldDropdown(profile["default"].ids), "ID");
            this.appendValueInput("STEPS", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.MOTOR_STEPPER_STEPS);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_PIN + " 1")
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN1")
                .appendField(Blockly.Msg.MOTOR_PIN + " 2")
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN2")
                .appendField(Blockly.Msg.MOTOR_PIN + " 3")
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN3")
                .appendField(Blockly.Msg.MOTOR_PIN + " 4")
                .appendField(new Blockly.FieldDropdown(profile["default"].digital), "PIN4");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    /**
     * motor_stepper_setspeed block definition
     */
    Blockly.Blocks.motor_stepper_setspeed = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_STEPPER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/stepper.svg", 50, 50))
                .appendField(Blockly.Msg.MOTOR_ID)
                .appendField(new Blockly.FieldDropdown([
                ["1", "1"],
                ["2", "2"],
                ["3", "3"],
                ["4", "4"]
            ]), "ID");
            this.appendValueInput("RPM", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.MOTOR_STEPPER_SPEED);
            this.appendDummyInput().appendField(Blockly.Msg.MOTOR_STEPPER_RPM);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    /**
     * motor_stepper_step block definition
     */
    Blockly.Blocks.motor_stepper_step = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_STEPPER)
                .appendField(new Blockly.FieldImage(img_path + "arduino/stepper.svg", 50, 50))
                .appendField(Blockly.Msg.MOTOR_ID)
                .appendField(new Blockly.FieldDropdown([
                ["1", "1"],
                ["2", "2"],
                ["3", "3"],
                ["4", "4"]
            ]), "ID");
            this.appendValueInput("STEP", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField(Blockly.Msg.MOTOR_STEPPER_STEP);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    
    /**
    * motor_dc_init block definition
    */

    Blockly.Blocks.motor_dc_init = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
                .appendField(Blockly.Msg.MOTOR_DC_MOTOR_DC)
                .appendField(new Blockly.FieldImage(img_path + "arduino/motor_dc.svg", 50, 50))
                .appendField(Blockly.Msg.MOTOR_DC_BEGIN)
                .appendField(Blockly.Msg.MOTOR_ID)
                .appendField(new Blockly.FieldDropdown(profile["default"].ids), "ID")
                .appendField(Blockly.Msg.MOTOR_PIN+" 1")
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN_A")
                .appendField(Blockly.Msg.MOTOR_PIN+" 2")
                .appendField(new Blockly.FieldDropdown(profile["default"].PWM), "PIN_B");
    
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    Blockly.Blocks.motor_dc_direction = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
            .appendField(Blockly.Msg.MOTOR_DC_MOTOR_DC)
            .appendField(new Blockly.FieldImage(img_path + "arduino/motor_dc.svg", 50, 50))
            .appendField(Blockly.Msg.MOTOR_DC_MOTOR)
            .appendField(new Blockly.FieldDropdown(profile["default"].ids), "ID")
            .appendField(Blockly.Msg.MOTOR_DC_DIRECTION)
            .appendField(new Blockly.FieldDropdown([
                [Blockly.Msg.MOTOR_DC_FORDWARD, "1"],
                [Blockly.Msg.MOTOR_DC_BACKWARD, "-1"],
            ]), "DIRECCION");

            this.appendValueInput("VELOCIDAD", "Number")
            .setCheck("Number")
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(Blockly.Msg.MOTOR_DC_SPEED);

            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };

    Blockly.Blocks.motor_dc_stop = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.motor.style);
            this.appendDummyInput()
            .appendField(Blockly.Msg.MOTOR_DC_MOTOR_DC)
            .appendField(new Blockly.FieldImage(img_path + "arduino/motor_dc.svg", 50, 50))
            .appendField(Blockly.Msg.MOTOR_DC_MOTOR)
            .appendField(new Blockly.FieldDropdown(profile["default"].ids), "ID")
            .appendField(Blockly.Msg.MOTOR_DC_STOP)

            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
}
